<template>
  <div class="container mx-auto">
    <el-dialog
      title="Nueva acción de personal"
      :visible.sync="showNewAction"
      width="1200px"
    >
      <el-form
        @submit.prevent.native="
          savePersonalAction('newActionForm', newActionForm)
        "
        :model="newActionForm"
        :rules="newActionFormRules"
        ref="newActionForm"
        status-icon
      >
        <el-row :gutter="15">
          <el-col :span="newActionForm.type === '1' ? 7 : 6">
            <el-form-item label="Tipo de acción" prop="type">
              <div class="flex w-full">
                <el-select
                  v-model="newActionForm.type"
                  placeholder="Seleccionar"
                  size="small"
                  clearable
                  filterable
                  @change="changeActionType(newActionForm.type)"
                  class="w-full"
                >
                  <el-option
                    v-for="(t, k) in types"
                    :key="k"
                    :label="t.name"
                    :value="t.id"
                  />
                </el-select>
                <el-checkbox
                  v-if="newActionForm.type === '1'"
                  v-model="newActionForm.baseSalary"
                  label="Aumenta salario base"
                  class="ml-3 mt-1"
                  border
                  size="small"
                  @change="changeBaseSalary()"
                ></el-checkbox>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="3" v-if="newActionForm.type === '1'">
            <el-form-item label="¿Descuento?" prop="needsApproval">
              <el-radio-group
                v-model="newActionForm.discount"
                class="w-full"
                :disabled="newActionForm.baseSalary"
                @change="newActionForm.affectsPaysheet = newActionForm.discount"
              >
                <el-radio :label="false">NO</el-radio>
                <el-radio :label="true">SI</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="newActionForm.type === '1' ? 6 : 10">
            <el-form-item label="Nombre de la acción" prop="name">
              <el-input
                v-model="newActionForm.name"
                auto-complete="off"
                size="small"
              />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              label="Tipo de asignación"
              prop="assignedBySupervisor"
            >
              <div class="flex w-full">
                <el-checkbox :value="true" disabled>RRHH</el-checkbox>
                <el-checkbox v-model="newActionForm.assignedBySupervisor"
                  >Supervisor</el-checkbox
                >
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="4" v-if="newActionForm.assignedBySupervisor">
            <el-form-item label="¿Necesita Aprobacion?" prop="needsApproval">
              <el-radio-group
                v-model="newActionForm.needsApproval"
                class="w-full"
              >
                <el-radio :label="false">NO</el-radio>
                <el-radio :label="true">SI</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15" class="border-t pt-4">
          <el-col :span="4">
            <el-form-item label="¿Afecta salario?" prop="affectsPaysheet">
              <el-radio-group
                v-model="newActionForm.affectsPaysheet"
                class="w-full"
              >
                <el-radio
                  :label="false"
                  :disabled="
                    newActionForm.type == '2' ||
                    newActionForm.type == '3' ||
                    newActionForm.baseSalary
                  "
                  >NO</el-radio
                >
                <el-radio :label="true">SI</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="4" v-if="newActionForm.affectsPaysheet">
            <el-form-item label="Forma de afectacion" prop="affectsMethod">
              <el-select
                v-model="newActionForm.affectsMethod"
                :value="null"
                placeholder="Seleccionar"
                size="small"
                clearable
                filterable
                class="w-full"
              >
                <el-option
                  v-for="(a, k) in affectMethods"
                  :key="k"
                  :label="a.name"
                  :value="a.id"
                />
                <el-option label="Fórmula" value="3" disabled />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5" v-if="newActionForm.affectsPaysheet">
            <el-form-item label="Valor afectado" prop="isFixedValue">
              <el-radio-group
                v-model="newActionForm.isFixedValue"
                class="w-full"
              >
                <el-radio :label="false">Variable</el-radio>
                <el-radio :label="true">Fijo</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col
            :span="3"
            v-if="newActionForm.affectsPaysheet && newActionForm.isFixedValue"
          >
            <el-form-item label="Valor fijo" prop="fixedValue">
              <el-input
                type="number"
                :step="newActionForm.affectsMethod == 1 ? 0.5 : 0.1"
                :min="0.5"
                v-model="newActionForm.fixedValue"
                size="small"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="showUpdateState">
            <el-row :gutter="15">
              <el-col :span="12" v-if="newActionForm.affectsPaysheet">
                <el-form-item label="¿Actualiza estado?" prop="updateStatus">
                  <el-radio-group
                    v-model="newActionForm.updateStatus"
                    class="w-full"
                    @change="newActionForm.status = ''"
                  >
                    <el-radio :label="false">NO</el-radio>
                    <el-radio :label="true">SI</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="newActionForm.updateStatus">
                <el-form-item label="Nuevo estado" prop="status">
                  <el-select
                    v-model="newActionForm.status"
                    placeholder="Seleccionar"
                    size="small"
                    clearable
                    filterable
                    class="w-full"
                  >
                    <el-option
                      v-for="(status, k) in statuses"
                      :key="k"
                      :label="status.name"
                      :value="status.id"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="15" v-if="newActionForm.affectsPaysheet">
          <div v-if="showIsrAffected">
            <el-col :span="6" v-if="newActionForm.affectsPaysheet">
              <el-form-item label="¿No aplica IGSS y Renta?" prop="deductISR">
                <el-radio-group
                  v-model="newActionForm.deductISR"
                  class="w-full"
                >
                  <el-radio :label="false">NO</el-radio>
                  <el-radio :label="true">SI</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </div>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showNewAction = false" size="small"
          >Cancelar</el-button
        >
        <el-button
          type="primary"
          @click="savePersonalAction('newActionForm', newActionForm)"
          size="small"
          >Guardar</el-button
        >
      </span>
    </el-dialog>

    <el-row :gutter="15" type="flex" justify="center">
      <el-col :span="24">
        <el-row :gutter="15">
          <el-col :span="24" class="mb-5">
            <h3 class="text-l font-semibold">ACCIONES DE PERSONAL</h3>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="24">
            <el-alert
              :closable="false"
              title="Administración de los tipos de acciones de personal que se pueden asignar a un empleado."
              type="info"
              show-icon
            />
          </el-col>
        </el-row>
        <el-row :gutter="15" type="flex" justify="space-between" class="my-5">
          <el-col :span="8">
            <el-button
              type="primary"
              size="small"
              @click="openNewPersonalAction"
              >Nueva acción de personal</el-button
            >
          </el-col>
          <el-col :span="5">
            <el-input
              placeholder="Buscar"
              v-model="searchValue"
              size="small"
              suffix-icon="el-icon-search"
            />
          </el-col>
        </el-row>
        <el-table :data="filteredActions" stripe size="mini">
          <el-table-column type="index" width="40" />
          <el-table-column label="Tipo" min-width="110">
            <template slot-scope="scope">
              <span>{{ getTypeName(scope.row.type) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="Nombre" min-width="320" />
          <el-table-column label="Asignable por" min-width="125">
            <template slot-scope="scope">
              <span
                >RRHH{{
                  scope.row.assignedBySupervisor ? ", Supervisor" : ""
                }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="affected"
            label="Afecta salario"
            min-width="100"
          >
            <template slot-scope="scope">
              <span>{{
                scope.row.affectsMethod === null
                  ? "N/A"
                  : getAffectedMethodName(scope.row.affectsMethod)
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Valor afectado" min-width="100" align="right">
            <template slot-scope="scope">
              <span v-if="scope.row.affectsMethod == '1'">{{
                scope.row.fixedValue
              }}</span>
              <span v-else-if="scope.row.affectsMethod == '2'">{{
                getFixedValue(scope.row.fixedValue) | formatMoney
              }}</span>
              <span v-else>N/A</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="country"
            label="Nuevo estado"
            min-width="100"
          />
          <el-table-column label="Estado" min-width="90" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.active">
                <el-tag type="success" size="small">Activo</el-tag>
              </span>
              <span v-else>
                <el-tag type="warning" size="small">Inactivo</el-tag>
              </span>
            </template>
          </el-table-column>
          <el-table-column width="80" align="center">
            <template slot-scope="scope">
              <el-dropdown trigger="click">
                <el-button
                  icon="el-icon-fa-ellipsis-v"
                  size="small"
                ></el-button>
                <el-dropdown-menu slot="dropdown" v-if="scope.row.editable">
                  <el-dropdown-item>
                    <!-- <span v-if="scope.row.active">
                          <i class="el-icon-fa-times"></i> Desactivar
                        </span> -->
                    <span v-if="!scope.row.active">
                      <i class="el-icon-fa-check"></i> Activar acción
                    </span>
                  </el-dropdown-item>
                  <el-dropdown-item
                    class="text-red-500 font-semibold"
                    @click.native="deletePersonalAction(scope.row)"
                  >
                    <i class="el-icon-fa-trash"></i> Eliminar
                  </el-dropdown-item>
                </el-dropdown-menu>
                <el-dropdown-menu slot="dropdown" v-else>
                  <el-dropdown-item>No hay acciones</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-row :gutter="15" type="flex" justify="end" class="mt-5">
          <el-pagination
            @size-change="handleSizeChange"
            :current-page.sync="page.number"
            :page-sizes="[5, 10, 15, 25, 50, 100]"
            :page-size="page.size"
            layout="total, sizes, prev, pager, next"
            :total="rawActions.length"
            :pager-count="5"
          />
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import axios from "axios";
import * as R from "ramda";
import { inputValidate, amountValidate } from "./../../../utils";

export default {
  name: "SettingsActions",
  beforeRouteEnter(to, from, next) {
    axios
      .post("/", {
        query: `
          {
            personalActions {
              id
              type
              name
              assignedBySupervisor
              affectsMethod
              fixedValue
              active 
              editable
              needsApproval
            }
          }`,
      })
      .then((res) => {
        const { data, errors } = res.data;
        if (R.isNil(errors)) {
          next((vm) => vm.setData(data.personalActions));
        } else {
          next(new Error(errors[0].message));
        }
      });
  },
  data() {
    return {
      types: [
        {
          name: "Administrativas",
          id: "1",
        },
        {
          name: "Gratificaciones",
          id: "2",
        },
        {
          name: "Descuentos",
          id: "3",
        },
      ],
      affectMethods: [
        {
          id: "1",
          name: "Días",
        },
        {
          id: "2",
          name: "Cantidad",
        },
      ],
      showNewAction: false,
      rawActions: [],
      searchValue: "",
      page: {
        size: 10,
        number: 1,
      },
      newActionForm: {
        type: "",
        name: "",
        assignedBySupervisor: false,
        affectsPaysheet: false,
        affectsMethod: null,
        isFixedValue: false,
        fixedValue: null,
        isRecurrent: false,
        recurrency: [],
        updateStatus: false,
        deductISR: false,
        status: null,
        baseSalary: false,
        needsApproval: true,
        discount: false,
      },
      newActionFormRules: {
        type: inputValidate("change", true),
        name: inputValidate("blur", true, 5, 50),
        affectsPaysheet: inputValidate("change", true),
        affectsMethod: inputValidate("change", true),
        isFixedValue: inputValidate("change", true),
        fixedValue: amountValidate("blur", true, 0.01),
        isRecurrent: inputValidate("change", true),
        recurrency: inputValidate("change", true),
        updateStatus: inputValidate("change", true),
        deductISR: inputValidate("change", true),
        status: inputValidate("change", true),
      },
      statuses: [],
      showUpdateState: false,
      showIsrAffected: false,
    };
  },
  methods: {
    setData(data) {
      this.rawActions = data;
    },
    handleSizeChange(val) {
      this.page.size = val;
    },
    openNewPersonalAction() {
      const form = this.$refs.newActionForm;
      if (!R.isNil(form)) {
        form.resetFields();
      }
      axios
        .post("/", {
          query: `{
            statuses(whereNot: { id: "1" }) { id name }
          }`,
        })
        .then((res) => {
          const { data, errors } = res.data;
          if (!R.isNil(data)) {
            this.statuses = data.statuses;
            this.showNewAction = true;
          }
        })
        .catch(console.log);
    },
    savePersonalAction(formName, form) {
      this.$refs[formName].validate(async (valid) => {
        if (!valid) {
          return false;
        }
        this.$confirm(
          "¿Estás seguro que deseas guardar esta acción de personal?",
          "Confirmación",
          {
            confirmButtonText: "Si, guardar",
            cancelButtonText: "Cancelar",
            type: "warning",
            beforeClose: (action, instance, done) => {
              if (action === "confirm") {
                instance.confirmButtonLoading = true;
                instance.confirmButtonText = "Procesando...";

                let mutation = `
                  type: "${form.type}",
                  name: "${form.name}",
                  assignedBySupervisor: ${form.assignedBySupervisor},
                  affectsPaysheet: ${form.affectsPaysheet},
                  discount: ${form.discount},`;

                if (form.affectsPaysheet) {
                  mutation += `
                    affectsMethod: "${form.affectsMethod}",
                    isFixedValue: ${form.isFixedValue},
                    isRecurrent: ${form.isRecurrent},
                    updateStatus: ${form.updateStatus},`;

                  mutation += form.isFixedValue
                    ? `fixedValue: ${form.fixedValue},`
                    : "";
                  mutation += form.updateStatus
                    ? `status: "${form.status}",`
                    : "";
                }

                if (form.assignedBySupervisor) {
                  mutation += `needsApproval: ${form.needsApproval},`;
                }

                if (form.type === "2" || form.type === "3") {
                  mutation += `deductISR: ${form.deductISR}`;
                }

                axios
                  .post("/", {
                    query: `mutation {
                      personalActionCreate(
                        data: { ${mutation} }
                      ){  
                        id
                        type
                        name
                        assignedBySupervisor
                        affectsMethod
                        fixedValue
                        active  
                        editable
                      }
                    }`,
                  })
                  .then((res) => {
                    const { data, errors } = res.data;
                    if (R.isNil(errors)) {
                      this.rawActions = data.personalActionCreate;
                      this.showNewAction = false;
                    }
                    this.$notify({
                      title: R.isNil(errors) ? "Éxito" : "Error",
                      message: R.isNil(errors)
                        ? "Se ha creado la acción de personal correctamente. "
                        : errors[0].message,
                      type: R.isNil(errors) ? "success" : "error",
                      duration: 3500,
                    });
                  })
                  .catch((error) => {
                    this.$notify({
                      title: "Error",
                      message:
                        "Ocurrió un error al guardar la accion de personal.",
                      type: "error",
                    });
                  })
                  .then((alw) => {
                    instance.confirmButtonLoading = false;
                    instance.confirmButtonText = "Si, guardar";
                    done();
                  });
              } else {
                done();
              }
            },
          }
        );
      });
    },
    changeActionType(type) {
      this.showUpdateState = false;
      this.showIsrAffected = false;
      this.newActionForm.baseSalary = false;
      this.newActionForm.deductISR = false;
      this.newActionForm.updateStatus = false;
      this.newActionForm.status = "";
      this.newActionForm.affectsPaysheet = false;
      switch (type) {
        case "1":
          this.showUpdateState = true;
          break;
        case "2":
          this.newActionForm.affectsPaysheet = true;
          this.showIsrAffected = true;
          break;
        case "3":
          this.newActionForm.affectsPaysheet = true;
          break;
      }
    },
    getTypeName(type) {
      return this.types.find((t) => t.id == type).name;
    },
    getAffectedMethodName(method) {
      return this.affectMethods.find((am) => am.id == method).name;
    },
    getFixedValue(value) {
      return value !== null ? value : 0;
    },
    getRecurrencyName(value) {
      return this.recurrencyList.find((r) => r.id == value).name;
    },
    deletePersonalAction({ id }) {
      this.$confirm(
        "¿Estás seguro que deseas eliminar esta accion de personal?",
        "Confirmación",
        {
          confirmButtonText: "Si, eliminar",
          cancelButtonText: "Cancelar",
          type: "warning",
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = "Procesando...";
              axios
                .post("/", {
                  query: `mutation {
                    personalActionDelete(where: {id: "${id}"}){
                      id
                      type
                      name
                      assignedBySupervisor
                      affectsMethod
                      fixedValue
                      active 
                      editable
                    }
                  }`,
                })
                .then((res) => {
                  const { data, errors } = res.data;
                  if (R.isNil(errors)) {
                    this.rawActions = data.personalActionDelete;
                  }
                  this.$notify({
                    title: R.isNil(errors) ? "Éxito" : "Error",
                    message: R.isNil(errors)
                      ? "Se ha eliminado la accion de personal correctamente"
                      : errors[0].message,
                    type: R.isNil(errors) ? "success" : "error",
                    duration: 3500,
                  });
                  instance.confirmButtonLoading = false;
                  instance.confirmButtonText = "Si, eliminar";
                  done();
                });
            } else {
              done();
            }
          },
        }
      );
    },
    changeBaseSalary() {
      this.newActionForm.affectsPaysheet = this.newActionForm.baseSalary;
      this.newActionForm.discount = !this.newActionForm.baseSalary;
    },
  },
  computed: {
    filteredActions() {
      return this.rawActions
        .filter((action) => {
          return action.name
            .toLowerCase()
            .includes(this.searchValue.toLowerCase());
        })
        .slice(
          this.page.number * this.page.size - this.page.size,
          this.page.size * this.page.number
        );
    },
  },
};
</script>
